import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Svg,
  Rect,
  Path,
} from '@react-pdf/renderer';

import backgroundGmud from '../../../assets/logos/background-gmud.png';
import logoERPWORKS from '../../../assets/logos/Logo ErpWorks Proposta.png';

// Font.register({
//   family: 'Arimo',
//   fonts: [
//     // eslint-disable-next-line no-undef
//     { src: require('../../../assets/fonts/Arimo/static/Arimo-Regular.ttf'), fontWeight: 'normal' },
//     // eslint-disable-next-line no-undef
//     { src: require('../../../assets/fonts/Arimo/static/Arimo-Bold.ttf'), fontWeight: 'bold' },
//   ],
// });

const styles = StyleSheet.create({
  page: {
    // fontFamily: 'Arimo',
    fontSize: 10,
    paddingTop: 80,
    paddingBottom: 50,
    paddingHorizontal: 40,
    backgroundColor: '#fff',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 100,
    width: '100%',
  },
  sectionTitle: {
    backgroundColor: '#cccccc',
    paddingVertical: 6,
    width: '100%',
    textAlign: 'center',
    // fontFamily: 'Arimo',
    fontWeight: 'bold',
    fontSize: 11,
  },
  cardTitle: {
    width: '100%',
    borderLeft: '1 solid #BDBDBD',
    minHeight: 28,
  },
  cardTitleBold: {
    fontWeight: 'bold',
    fontSize: 8,
    borderBottom: '1 solid #BDBDBD',
    paddingLeft: 6,
    paddingVertical: 2,
  },
  cardTitleNormal: {
    fontSize: 8,
    paddingLeft: 6,
  },
  row: {
    flexDirection: 'row',
    width: '100%',
  },
  firstCell: {
    flex: 1,
    maxWidth: 64,
    border: '1 solid #BDBDBD',
    padding: 8,
    fontSize: 9,
  },
  cell: {
    flex: 1,
    border: '1 solid #BDBDBD',
    padding: 8,
    fontSize: 9,
  },
  tableHeader: {
    backgroundColor: '#dbdbdb',
    fontWeight: 'bold',
  },
  checkbox: {
    fontSize: 12,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    textAlign: 'center',
    fontSize: 10,
    padding: 10,
    color: '#888',
    backgroundColor: '#5269a770',
  },
  watermark: {
    position: 'absolute',
    top: 100,
    bottom: 100,
    right: 10,
    width: 15,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0.4,
  },
  watermarkText: {
    fontSize: 6,
    color: '#5269a7',
    fontWeight: 'normal',
    lineHeight: 1,
    textAlign: 'center',
    transform: 'rotate(90deg)',
  },
});

const CardTitle = ({ title, subTitle, containerStyle }) => (
  <View style={[styles.cardTitle, containerStyle]}>
    <Text style={styles.cardTitleBold}>{title}</Text>
    <Text style={styles.cardTitleNormal}>{subTitle}</Text>
  </View>
);

const SectionTitle = ({ title, style }) => (
  <Text style={[styles.sectionTitle, style]}>{title}</Text>
);

const CardText = ({ text, linksTdnTotvs, containerStyle }) => (
  <View style={[{ border: '1 solid #BDBDBD', padding: 6 }, containerStyle]}>
    <Text style={{ fontSize: 9 }}>
      {text.replace(/(https?:\/\/[^\s]+)/g, url => url.replace(/(.{40})/g, '$1\u200B'))}
    </Text>
    {linksTdnTotvs && linksTdnTotvs.length > 0 && (
      <View style={{ borderTop: '1 solid #BDBDBD', paddingTop: 8, marginTop: 8, gap: 6 }}>
        <Text style={{ fontSize: 9, fontWeight: 'bold' }}>TDN Links:</Text>
        {linksTdnTotvs.map(
          (link, index) =>
            link.url && (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{
                    fontSize: 9,
                    color: '#0066cc',
                    textDecoration: 'underline',
                    fontWeight: 'normal',
                  }}
                >
                  {link.url}
                </Text>
              </View>
            ),
        )}
      </View>
    )}
  </View>
);

const Checkbox = ({ checked, label }) => (
  <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 2 }}>
    <Svg width="12" height="12" style={{ marginRight: 4 }}>
      <Rect x="1" y="1" width="10" height="10" stroke="#333" strokeWidth="1" fill="none" />
      {checked && (
        <>
          <Path d="M3 3 L9 9" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
          <Path d="M9 3 L3 9" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </>
      )}
    </Svg>
    <Text>{label}</Text>
  </View>
);

export default function GmudPdfTemplatePDF(gmudData) {
  const {
    clienteSolicitanteGmud,
    area,
    janelaAcordadaComQuem,
    dataSolicitacao,
    descricaoMudanca,
    descricaoAtividade,
    linksTdnTotvs,
    moduloTotvs,
    prioridade,
    categoria,
    origem,
    ambiente,
    finalidade,
    tempoIndisponibilidadeEmMinutos,
    dataHoraInicio,
    dataHoraFim,
    execucao,
    validacao,
    rollback,
    escalonamento,
    atualizacaoDeLib,
    atualizacaoDeMashup,
    atualizacaoDePatch,
    atualizacaoDeStoredProcedure,
    atualizacaoDeSchemasTss,
    atualizacaoDeTss,
    atualizacaoDeUpddistr,
    compilaFonte,
    outros,
    outraClassificacao,
    githubHashCommit,
    dependeDeOutraMudancaQual,
  } = gmudData;

  function getTotalTempoPrevisto(execucao) {
    if (!Array.isArray(execucao)) return 0;
    return execucao.reduce((total, item) => {
      const min = Number(item.tempoPrevistoEmMinutos) || 0;
      return total + min;
    }, 0);
  }

  const totalTempoPrevisto = getTotalTempoPrevisto(execucao);

  function formatMinutesToHourString(minutes) {
    if (!minutes || isNaN(minutes)) return '';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h && m) return `${h}h ${m}min`;
    if (h) return `${h}h`;
    if (m) return `${m}min`;
    return '0min';
  }
  function formatDateWithHours(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* Header */}
        <View style={styles.header} fixed>
          <View style={{ position: 'relative', width: '100%', height: 'auto' }}>
            <Image src={backgroundGmud} />
            <Image
              src={logoERPWORKS}
              style={{
                width: 120,
                height: 30,
                position: 'absolute',
                top: 30,
                right: 40,
              }}
            />
          </View>
        </View>

        {/* Watermark */}
        <View style={styles.watermark} fixed>
          {'Documento de uso Confidencial entre a Erpworks e seus destinatários. A sua utilização é exclusivamente para os membros autorizados destas partes – Não Reproduzir - Erpworks - Todos os Direitos Reservados ®'
            .split('')
            .map((char, index) => (
              <Text key={index} style={styles.watermarkText}>
                {char}
              </Text>
            ))}
        </View>

        {/* Título */}
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            border: '1 solid #BDBDBD',
          }}
        >
          {/* <Image
            src={logoERPWORKS}
            style={{
              width: 100,
              height: 30,
              padding: 4,
              borderRight: '1 solid #BDBDBD',
              fontFamily: 'Arimo',
              fontWeight: 'bold',
            }}
          /> */}
          <Text
            style={{
              fontSize: 13,
              fontWeight: 800,
              color: '#5269a7',
              padding: 4,
              width: '100%',
              textAlign: 'center',
            }}
          >
            Formulário de Requisição de Mudança (RDM)
          </Text>
        </View>

        {/* Dados do Solicitante */}
        <SectionTitle title="Dados do Solicitante" />
        <View style={[styles.row, { justifyContent: 'space-between', border: '1 solid #BDBDBD' }]}>
          <CardTitle
            title="Solicitante:"
            subTitle={clienteSolicitanteGmud?.nome || ''}
            containerStyle={{ borderleft: '1px solid transparent' }}
          />
          {/* <CardTitle title="Área:" subTitle={area || ''} /> */}
          <CardTitle title="Telefone:" subTitle={clienteSolicitanteGmud?.telefone || ''} />
          <CardTitle title="E-mail:" subTitle={clienteSolicitanteGmud?.email || ''} />
          <CardTitle title="Data da Solicitação:" subTitle={formatDate(dataSolicitacao) ?? ''} />
          <CardTitle
            title="Módulo:"
            subTitle={moduloTotvs?.nome + ' - ' + moduloTotvs?.descricao}
          />
        </View>

        {/* Descrição da Mudança */}
        <SectionTitle title="Descrição da Mudança" />
        <CardText text={descricaoMudanca || ''} containerStyle={{ minHeight: 60 }} />

        {/* Descrição da Atividade */}
        <SectionTitle title="Descrição da Atividade" />
        <CardText
          linksTdnTotvs={linksTdnTotvs}
          text={descricaoAtividade || ''}
          containerStyle={{ minHeight: 90 }}
        />

        {/* Prioridade, Origem, Ambiente */}
        <View style={[styles.row]} wrap={false}>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="CATEGORIA" />

            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={categoria === 'agendada'} label="Agendada" />
              <Checkbox checked={categoria === 'emergencial'} label="Emergencial" />
              <Checkbox checked={categoria === 'padrao'} label="Padrão" />
            </View>
          </View>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="ORIGEM" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={origem === 'projeto'} label="Projeto" />
              <Checkbox checked={origem === 'incidente'} label="Incidente" />
              <Checkbox checked={origem === 'produto'} label="Produto" />
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Checkbox checked={origem === 'ticket'} label="Ticket" />
                {origem === 'ticket' && gmudData.numeroTicket && (
                  <Text style={{ fontSize: 9 }}>: #{gmudData.numeroTicket}</Text>
                )}
              </View>
            </View>
          </View>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="AMBIENTE" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={ambiente === 'desenvolvimento'} label="Desenvolvimento" />
              <Checkbox checked={ambiente === 'producao'} label="Produção" />
            </View>
          </View>
        </View>

        {/* Finalidade e Classificação */}
        <View style={[styles.row]} wrap={false}>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="FINALIDADE" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={finalidade === 'melhoria'} label="Melhoria" />
              <Checkbox checked={finalidade === 'teste'} label="Teste" />
              <Checkbox checked={finalidade === 'projeto'} label="Projeto" />
              <Checkbox checked={finalidade === 'upgrade'} label="Upgrade" />
              <Checkbox checked={finalidade === 'preventiva'} label="Preventiva" />
              <Checkbox checked={finalidade === 'corretiva'} label="Corretiva" />
              <Checkbox checked={finalidade === 'preventiva'} label="Preventiva" />
            </View>
          </View>
          <View style={{ flex: 2, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="CLASSIFICAÇÃO" />
            <View style={{ flexDirection: 'row', gap: 4 }}>
              <View style={{ padding: 6, gap: 4, borderRight: '1 solid #BDBDBD' }}>
                <Checkbox checked={atualizacaoDePatch} label="Atualização de Patch" />
                <Checkbox checked={atualizacaoDeMashup} label="Atualização de Mashup" />
                <Checkbox
                  checked={atualizacaoDeStoredProcedure}
                  label="Atualização de Stored Procedure"
                />
                <Checkbox checked={atualizacaoDeSchemasTss} label="Atualização de Schemas TSS" />
                <Checkbox checked={atualizacaoDeTss} label="Atualização de TSS" />
                <Checkbox checked={atualizacaoDeLib} label="Atualização de Lib" />
              </View>
              <View style={{ padding: 6, gap: 4 }}>
                <Checkbox checked={atualizacaoDeUpddistr} label="Atualização de UPDDISTR" />
                <View>
                  <Checkbox checked={compilaFonte} label="Compila Fonte" />
                  {githubHashCommit && (
                    <Text style={{ fontSize: 9 }}>
                      {' - ' + githubHashCommit.replace(/(.{25})/g, '$1\n')}
                    </Text>
                  )}
                </View>
                <View>
                  <Checkbox checked={outros} label="Outros:" />
                  {outraClassificacao && (
                    <Text style={{ fontSize: 9 }}> - {outraClassificacao}</Text>
                  )}
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Prioridade e Haverá Indisponibilidade */}
        <View style={[styles.row]} wrap={false}>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="PRIORIDADE" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={prioridade === 'baixa'} label="Baixa" />
              <Checkbox checked={prioridade === 'media'} label="Média" />
              <Checkbox checked={prioridade === 'alta'} label="Alta" />
            </View>
          </View>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="HAVERÁ INDISPONIBILIDADE?" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={tempoIndisponibilidadeEmMinutos ? false : true} label="Não" />
              <Checkbox checked={tempoIndisponibilidadeEmMinutos ? true : false} label="Sim" />
              {tempoIndisponibilidadeEmMinutos && (
                <Text style={{ fontWeight: 'bold' }}>
                  Quanto tempo?
                  <Text style={{ fontWeight: 'normal' }}>
                    {`\n - ${formatMinutesToHourString(tempoIndisponibilidadeEmMinutos || '')}`}
                  </Text>
                </Text>
              )}
            </View>
          </View>
        </View>

        {/* Janela Acordada e Pendência */}
        <View style={[styles.row]} wrap={false}>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle title="JANELA ACORDADA?" />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={janelaAcordadaComQuem ? false : true} label="Não" />
              <Checkbox checked={janelaAcordadaComQuem ? true : false} label="Sim" />

              {janelaAcordadaComQuem && (
                <Text style={{ fontWeight: 'bold' }}>
                  Com quem?{' '}
                  <Text style={{ fontWeight: 'normal' }}>
                    <Text style={{ fontWeight: 'normal' }}>{`\n - ${
                      janelaAcordadaComQuem || ''
                    }`}</Text>
                  </Text>
                </Text>
              )}
            </View>
          </View>
          <View style={{ flex: 1, border: '1 solid #BDBDBD' }}>
            <SectionTitle
              title="HÁ PENDÊNCIA DE OUTRA MUDANÇA PARA EXECUÇÃO DESTA?"
              style={{ fontSize: 8, paddingVertical: 8 }}
            />
            <View style={{ padding: 6, gap: 4 }}>
              <Checkbox checked={dependeDeOutraMudancaQual ? false : true} label="Não" />
              <Checkbox checked={dependeDeOutraMudancaQual ? true : false} label="Sim" />
              {dependeDeOutraMudancaQual && (
                <Text style={{ fontWeight: 'bold' }}>
                  Qual?
                  <Text style={{ fontWeight: 'normal' }}>{`\n - ${
                    dependeDeOutraMudancaQual || ''
                  }`}</Text>
                </Text>
              )}
            </View>
          </View>
        </View>

        {/* Datas */}
        <View style={[styles.row]} wrap={false}>
          <View style={{ flex: 1 }}>
            <SectionTitle title="DATA E HORÁRIO DE INÍCIO" style={{ fontSize: 8 }} />
            <CardText text={formatDateWithHours(dataHoraInicio) || ''} />
          </View>
          <View style={{ flex: 1 }}>
            <SectionTitle title="DATA E HORÁRIO DE TÉRMINO" style={{ fontSize: 8 }} />
            <CardText text={formatDateWithHours(dataHoraFim) || ''} />
          </View>
          <View style={{ flex: 1 }}>
            <SectionTitle title="DATA E HORÁRIO LIMITE" style={{ fontSize: 8 }} />
            <CardText text={formatDateWithHours(dataHoraFim) || ''} />
          </View>
        </View>

        {/* Tabelas (Plano de Execução, Validação, Rollback, Escalonamento) */}
        <View wrap={false}>
          <SectionTitle title="PLANO DE EXECUÇÃO DA MUDANÇA" />
          <View>
            <View style={[styles.row, styles.tableHeader]}>
              <Text style={styles.firstCell}>Sequência</Text>
              <Text style={styles.cell}>Atividade</Text>
              <Text style={styles.cell}>Responsável</Text>
              <Text style={styles.cell}>Data/Hora Início</Text>
              <Text style={styles.cell}>Tempo Previsto</Text>
            </View>

            <View>
              {execucao?.length > 0 &&
                execucao.map((item, idx) => (
                  <View style={styles.row} key={item.id}>
                    <Text style={styles.firstCell}>{idx + 1}</Text>
                    <Text style={styles.cell}>{item.descricao}</Text>
                    <Text style={styles.cell}>{item.responsavel.nome}</Text>
                    <Text style={styles.cell}>{formatDateWithHours(item.dataHoraInicio)}</Text>
                    <Text style={styles.cell}>
                      {formatMinutesToHourString(item.tempoPrevistoEmMinutos)}
                    </Text>
                  </View>
                ))}
              <View style={styles.row}>
                <Text style={styles.firstCell}>{execucao?.length + 1}</Text>
                <Text style={styles.cell}></Text>
                <Text style={styles.cell}></Text>
                <Text style={styles.cell}></Text>
                <Text style={styles.cell}></Text>
              </View>
              <View
                style={{
                  ...styles.row,
                  gap: 8,
                  borderLeft: '1 solid #BDBDBD',
                  borderRight: '1 solid #BDBDBD',
                }}
              >
                <Text style={[styles.tableHeader, { padding: 8, paddingRight: 18, fontSize: 9.5 }]}>
                  Previsão Hora Final da Execução de Todas as Atividades:{' '}
                </Text>
                <Text style={{ paddingVertical: 8 }}>
                  {formatMinutesToHourString(totalTempoPrevisto)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View wrap={false}>
          <SectionTitle title="PLANO DE VALIDAÇÃO DA MUDANÇA" />
          <View>
            <View style={[styles.row, styles.tableHeader]}>
              <Text style={styles.firstCell}>Sequência</Text>
              <Text style={styles.cell}>Descrição da ação</Text>
              <Text style={styles.cell}>Resultado esperado</Text>
              <Text style={[styles.cell, { maxWidth: 90 }]}>Passou/Falhou</Text>
              <Text style={styles.cell}>Comentário</Text>
            </View>
            {validacao &&
              validacao.map((seq, index) => (
                <View style={styles.row} key={seq.id}>
                  <Text style={styles.firstCell}>{index + 1}</Text>
                  <Text style={styles.cell}>{seq.descricao}</Text>
                  <Text style={styles.cell}>{seq.resultado}</Text>
                  <Text style={[styles.cell, { maxWidth: 90 }]}>
                    {/* <Checkbox checked={seq.passfail ? true : false} label="Sim" />
                    <Checkbox checked={seq.passfail ? false : true} label="Não" /> */}
                    {seq.passfail === null ? (
                      <text></text>
                    ) : (
                      <text>{seq.passfail ? 'Sim' : 'Não'}</text>
                    )}
                  </Text>
                  <Text style={styles.cell}>{seq.comentario}</Text>
                </View>
              ))}

            <View style={styles.row}>
              <Text style={styles.firstCell}>{validacao?.length + 1}</Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={[styles.cell, { maxWidth: 90 }]} />
              <Text style={styles.cell}></Text>
            </View>
          </View>
        </View>

        <View wrap={false}>
          <SectionTitle title="PLANO DE ROLLBACK (PARA O CASO DE PROBLEMAS)" />
          <View>
            <View style={[styles.row, styles.tableHeader]}>
              <Text style={styles.firstCell}>Sequência</Text>
              <Text style={styles.cell}>Descrição da ação</Text>
              <Text style={styles.cell}>Responsável</Text>
              <Text style={styles.cell}>Data/Hora</Text>
              <Text style={styles.cell}>Comentário</Text>
            </View>
            {rollback &&
              rollback.map((seq, index) => (
                <View style={styles.row} key={seq.id}>
                  <Text style={styles.firstCell}>{index + 1}</Text>
                  <Text style={styles.cell}>{seq.descricao}</Text>
                  <Text style={styles.cell}>{seq?.responsavel?.nome || ''}</Text>
                  <Text style={styles.cell}>{formatDateWithHours(seq.datahora)}</Text>
                  <Text style={styles.cell}>{seq.comentario}</Text>
                </View>
              ))}
            <View style={styles.row}>
              <Text style={styles.firstCell}>{rollback?.length + 1}</Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
            </View>
          </View>
        </View>

        <View wrap={false}>
          <SectionTitle title="PLANO DE ESCALONAMENTO EM CASO DE PROBLEMAS" />
          <View>
            <View style={[styles.row, styles.tableHeader]}>
              <Text style={styles.firstCell}>Sequência</Text>
              <Text style={styles.cell}>Nome</Text>
              <Text style={styles.cell}>Contato</Text>
              {/* <Text style={styles.cell}>Telefone</Text>
              <Text style={styles.cell}>E-mail</Text> */}
            </View>
            {escalonamento &&
              escalonamento.map((seq, index) => (
                <View style={styles.row} key={seq.id}>
                  <Text style={styles.firstCell}>{index + 1}</Text>
                  <Text style={styles.cell}>{seq?.responsavel?.nome || ''}</Text>
                  {/* <Text style={styles.cell}>{seq?.responsavel?.telefone || ''}</Text> */}
                  <Text style={styles.cell}>{seq?.responsavel?.email || ''}</Text>
                </View>
              ))}
            <View style={styles.row}>
              <Text style={styles.firstCell}>{escalonamento?.length + 1}</Text>
              {/* <Text style={styles.cell}></Text> */}
              <Text style={styles.cell} />
              <Text style={styles.cell} />
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text>TMSIGA Serviços em Informática Ltda – “Erpworks Professional Services”</Text>
          <Text>Av. Mofarrej, 348 – CJ 1308 - Vila Leopoldina - São Paulo/SP | CEP: 05311-000</Text>
          <Text>(11) 5181-3095 atendimento@erpworks.com.br http://www.erpworks.com.br</Text>
        </View>
      </Page>
    </Document>
  );
}
